import { render } from "./organizationCard.vue?vue&type=template&id=d87348c0&scoped=true"
import script from "./organizationCard.vue?vue&type=script&lang=js"
export * from "./organizationCard.vue?vue&type=script&lang=js"

import "./organizationCard.vue?vue&type=style&index=0&id=d87348c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87348c0"]])

export default __exports__